<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div>
        <span>单据编号：</span>
        <span>{{ parseStrEmpty(formData.inboundBizNo) }}</span>
      </div>
    </div>
    <el-form :model="formData" ref="form">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            客户名称：
            <span>{{parseStrEmpty(formData.customerName)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            入库类型：
            <span>{{parseStrEmpty(formData.inboundTypeText)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            采摘批次：
            <span>{{parseStrEmpty(formData.pickingBatchBizNo)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            满框框数：
            <span>{{parseStrEmpty(formData.fullBasketCount)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            总框数：
            <span>{{parseStrEmpty(formData.totalBasketCount)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            产品名称：
            <span>{{parseStrEmpty(formData.productName)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            总净重：
            <span>{{parseStrEmpty(formData.totalNetWeight)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            产区：
            <span>{{parseStrEmpty(formData.locAddress)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            仓库：
            <span>{{parseStrEmpty(formData.inventoryLocation)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            年份：
            <span>{{parseStrEmpty(formData.year)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            仓管：
            <span>{{parseStrEmpty(formData.inventoryManager)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            培育方式：
            <span>{{parseStrEmpty(formData.cultivationMethodSpecValueKey)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            入库日期：
            <span>{{parseStrEmpty(formData.inboundDateTime)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            成熟度：
            <span>{{parseStrEmpty(formData.ripenessLevelSpecAttrValueKey)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            满框定重：
            <span>{{parseStrEmpty(formData.fullRatedWeight)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            尾框重量：
            <span>{{parseStrEmpty(formData.tailWeight)}}</span>
          </span>
        </el-col>
      </el-row>
    </el-form>
    <div class="title title-mt">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">入库明细</div>
      </div>
    </div>

    <div class="topmargin">
      <TablePublic 
        :colLists="colLists" 
        :tableData="formData.checkRecordList" 
        :showIndex="false" 
        :paginationFlag="false"
        :arraySpanMethod="objectSpanMethod"
      >
        <template slot="solts" slot-scope="scope">
          <el-button
            class="button"
            type="text"
            size="small"
            @click="handleContentView(scope.data, '查看')"
          >明细</el-button>
        </template>
      </TablePublic>
    </div>

    <div class="title title-mt title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">照片信息</div>
        <el-button class="line-button" @click="handleImgUpload">保存照片</el-button>
      </div>
    </div>
    <el-upload
      action="#"
      accept=".jpg, .jpeg, .png, .webp, .gif"
      list-type="picture-card"
      :on-change="handleImgDebounce"
      :file-list="fileList"
      :auto-upload="false"
      :multiple="true"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file.url)">
            <i class="el-icon-zoom-in"></i>
            <el-image 
              :ref="file.url"
              style="position: absolute;top: -100%;"
              :src="file.url" 
              :preview-src-list="fileViewList">
            </el-image>
          </span>
          <span class="el-upload-list__item-delete" @click="handleImgRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <!-- 保存照片loading -->
    <div class="loadingMain" v-if="loading">
      <div 
        class="loadingContent"
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="transparent"
      ></div>
    </div>
    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="cancel"
    >
      <component
        v-if="dialogVisible"
        :ref="currentView"
        :is="currentView"
      ></component>
    </Mdialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getWarehouseDetail, uploadWarehouse, uploadSaveWarehouse } from '@/api/manage/warehouse'
import contentDetail from '@/views/warehouse/statistic/components/contentDetail'
import TablePublic from '@/components/tablePublic'
import Mdialog from '@/components/Mdialog'
import { debounce } from '@/utils/common';
export default {
  components: {
    contentDetail,
    TablePublic,
    Mdialog
  },
  data() {
    return {
      loading: false,
      loadingText: '正在上传照片中...',
      dialogImgVisible: false,
      dialogVisible: false,
      dialogWidth: '',
      title: '',
      currentView: '',
      colLists: [
        {
          prop: 'storageAreaName',
          label: '库区',
          isTrue: true,
        },
        {
          prop: 'storageLocName',
          label: '库位',
          isTrue: true,
        },
        {
          prop: 'storageTrayName',
          label: '托盘号',
          isTrue: true,
        },
        {
          prop: 'depositTotalNetWeight',
          label: '存放净重（斤）',
          isTrue: true,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      fileList: [],
      fileViewList: [],
      formData: {
        checkRecordList: [],
      },
      // table合并列
      spanArr1: [], // 记录每一行的合并数
      pos1: '', // 记录索引
    }
  },
  computed: {
    ...mapState({
      inboundTypeList: (state) => (state.system.dictList && state.system.dictList.InboundType) || [],
    }),
  },
  created() {
    this.handleImgDebounce = debounce(this.handleImgChange, 500)
  },
  methods: {
    getDetails(row) {
      if (row) {
        getWarehouseDetail(row.id).then((res) => {
          if (res.flag) {
            this.formData = {
              ...res.data,
              locAddress: this.formatLocal(res.data.locDetails, -1),
              inboundDateTime: this.parseTime(res.data.stockedTime, '{y}-{m}-{d}'),
              inboundTypeText: this.inboundTypeList.find(d=>d.dictValue == res.data.inboundType)?.dictLabel,
              checkRecordList: res.data.checkRecordList && res.data.checkRecordList.map(d=>{
                d.customerName = res.data.customerName
                return d
              })
            }
            this.fileList = this.formData.attachments.map(d=>{
              return {
                url: d.url,
                name: d.name,
                type: d.type,
              }
            })
            this.fileViewList = this.formData.attachments.map(d=>d.url)
          }
        })
      }
    },
    handleImgChange(file, fileList) {
      let fileData = []
      let strRegex = /\.(jpg|png|gif|jpeg|webp)$/
      fileList.forEach(item => {
        const index = item.name.lastIndexOf('.')
        const suffix = item.name.substring(index, item.name.length)
        if (!strRegex.test(suffix.toLowerCase())) {
          this.$message.warning('请上传扩展名为：.jpg, .jpeg, .png, .webp, .gif 的文件')
        }else{
          fileData.push(item)
        }
      });
      this.fileList = fileData
      this.fileViewList = fileData.map(f=>f.url);
    },
    handlePictureCardPreview(image) {
      this.$refs[image].showViewer = true;
    },
    handleImgRemove(file) {
      const index = this.fileList.findIndex(f => f.uid === file.uid);
      if (index !== -1) {
        // 移除文件
        this.fileList.splice(index, 1);
      }
    },
    //多张上传
    async handleImgUpload() {
      if(!this.fileList || this.fileList.length <= 0){
        this.$message.warning('请上传至少一张照片');
        return
      }
      let uploadPromises = this.fileList.filter(item => item.raw)
        .map(item => {
          return new Promise((resolve, reject) => {
            let formData = new FormData()
            formData.append('file', item.raw)
            uploadWarehouse(formData).then(res => {
              resolve(res); 
            }).catch(error => {
              console.log('上传图片失败：', error);
              reject(error); 
            });
          });
      });
      this.loading = true
      this.loadingText = "正在上传照片中..."
      Promise.allSettled(uploadPromises).then((results) => {
        // 所有图片上传完成后的操作,过滤出所有成功的结果  
        const uploadObj = results.map(result => {  
          if (result.status === 'fulfilled') {  
            return result.value;  
          }  
        }).filter(item => item.code == 200 && item.flag);
        this.uploadSaveWarehouse(uploadObj)
      }).catch(error => {
        this.loading = false
        console.log(error)
      });
    },
    //保存照片
    async uploadSaveWarehouse(uploadObj){
      let fileData = this.fileList.filter(item => !item.raw);
      let uploadForm = Object.assign({},{
        id: this.formData.id,
        attachments: [...fileData,...uploadObj.map(upload=>{
          return {
            url: upload.data.url,
            name: upload.data.name,
            type: 2,
          }
        })]
      })
      this.loadingText = "保存照片中..."
      let result = await uploadSaveWarehouse(uploadForm)
      if (result.code == 200 && result.flag) {
        this.$message.success('保存成功')
        this.loading = false
        // this.$emit('closes')
      } else {
        this.$message.error(result.message)
        this.loading = false
      }
    },
    // 合并行
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: this.mergeIndexRows(row, this.formData.checkRecordList, rowIndex, ['storageAreaCode']),
          colspan: 1,
        }
      }
      if (columnIndex === 1) {
        return {
          rowspan: this.mergeIndexRows(row, this.formData.checkRecordList, rowIndex, ['storageLocCode']),
          colspan: 1,
        }
      }
    },
    handleContentView(row) {
      this.type = 'preview'
      this.title = '查看容器明细'
      this.currentView = 'contentDetail'
      this.dialogWidth = '50%'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    cancel() {
      this.dialogVisible = false
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
.topmargin {
  margin-top: 20px;
}
.line {
  display: flex;
  word-break: keep-all;
  padding: 8px 0;
  span{
    word-break: break-all;
  }
}
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-top: 10px;
  }
}
/deep/ .el-upload-list{
  .el-upload-list__item>div{
    height: 100%;
  }
}
/deep/ .loadingMain{
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
  left: 0;
  top: 0;
  .loadingContent{
    position: absolute;
    width: 300px;
    height: 160px;
    border-radius: 10px;
    background: rgba(0,0,0,0.6);
    margin-left: -150px;
    margin-top: -80px;
    left: 50%;
    top: 50%;
    .el-icon-loading{
      color: #FFF;
      font-size: 30px;
    }
    .el-loading-text{
      color: #FFF;
    }
  }
}
</style>